import {
  Component,
  ComponentRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from '@interfaces';

@Component({
  selector: 'frontend-workspace-custom-modal',
  templateUrl: './custom-modal.component.html',
  styleUrls: ['./custom-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CustomModalComponent implements OnInit, OnDestroy {
  private dialogRef = inject<MatDialogRef<DialogData>>(MatDialogRef);
  private viewContainerRef = inject(ViewContainerRef);
  data = inject<DialogData>(MAT_DIALOG_DATA);

  @ViewChild('target', { read: ViewContainerRef, static: true })
  vcRef!: ViewContainerRef;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  componentRef!: ComponentRef<any>;

  ngOnInit(): void {
    if (this.data.component) {
      this.componentRef = this.viewContainerRef.createComponent(
        this.data.component,
      );

      this.componentRef.instance.data = this.data.nestedData;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }
}
